<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="tabName">
</app-page-heading>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">
        <mat-step #generalStep [completed]="generalFormGroup">
            <ng-template matStepLabel>General</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy Name</mat-label>
                            <input matInput type="text" [formControl]="policyNameFormControl" [readonly]="true"
                                (blur)="blurPolicyNameHeading()">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policy Name')">help_outline</mat-icon>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Administrator</mat-label>
                            <input matInput type="text" [formControl]="administratorFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Administrator')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy Number</mat-label>
                            <input matInput type="text" [formControl]="policyNumberFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policy Number')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Payer</mat-label>
                            <input matInput type="text" [formControl]="payerFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Payer')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policyholder</mat-label>
                            <input matInput type="text" [formControl]="policyholderFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policyholder')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Currency</mat-label>
                            <input matInput type="text" [formControl]="currencyFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Currency')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Renewal of Policy</mat-label>
                            <input matInput type="text" [formControl]="renewalOfPolicyFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Renewal of Policy')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Renewed by Policy</mat-label>
                            <input matInput type="text" [formControl]="renewedByPolicyFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Renewed by Policy')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button color="warn" disabled>Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step #statusStep [completed]="statusFormGroup">
            <ng-template matStepLabel>Status</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy Start Date</mat-label>
                            <input [formControl]="policyStartDateFormControl" [readonly]="true"
                                [matDatepicker]="policyStartDatePicker" matInput>
                            <mat-datepicker #policyStartDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Policy Start Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Cover Status</mat-label>
                            <input matInput type="text" [formControl]="coverStatusFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Cover Status')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy End Date</mat-label>
                            <input [formControl]="policyEndDateFormControl" [readonly]="true"
                                [matDatepicker]="policyEndDatePicker" matInput>
                            <mat-datepicker #policyEndDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Policy End Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Status Start Date</mat-label>
                            <input [formControl]="statusStartDateFormControl" [readonly]="true"
                                [matDatepicker]="statusStartDatePicker" matInput>
                            <mat-datepicker #statusStartDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Status Start Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy Activation Date</mat-label>
                            <input [formControl]="policyActivationDateFormControl" [readonly]="true"
                                [matDatepicker]="policyActivationDatePicker" matInput>
                            <mat-datepicker #policyActivationDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Policy Activation Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Status End Date</mat-label>
                            <input [formControl]="statusEndDateFormControl" [readonly]="true"
                                [matDatepicker]="statusEndDatePicker" matInput>
                            <mat-datepicker #statusEndDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Status End Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Policy Application Date</mat-label>
                            <input [formControl]="policyApplicationDateFormControl" [readonly]="true"
                                [matDatepicker]="policyApplicationDatePicker" matInput>
                            <mat-datepicker #policyApplicationDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('Policy Application Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-divider style="margin-bottom: 16px;margin-top: 16px;"></mat-divider>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                    </mat-grid-tile>
                    <mat-grid-tile >
                      <div>
                        <div class="left-content">
                          <label class="column-label claim-column-label">Status History</label>
                        </div>
                        <div class="left-content reporting-list" *ngFor="let coverStatuses of selectedCoverStatuses">
                          <p>
                            {{getCoveredStatusDisplayString(coverStatuses)}}
                          </p>
                        </div>
                      </div>
                    </mat-grid-tile>
                  </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" disabled>Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step #premiumParametersStep [completed]="premiumParametersFormGroup">
            <ng-template matStepLabel>Premium Parameters</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <label>Bill to Group</label>
                        <mat-radio-group [(ngModel)]="isBillToGroup" disabled [ngModelOptions]="{standalone: true}"
                                         aria-label="Select yes OR no" class="example-radio-group">
                          <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                            Yes &nbsp;
                          </mat-radio-button>
                          <mat-radio-button class="radio-button" value="No" checked>
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Bill to group')">help_outline</mat-icon>
                      </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Broker</mat-label>
                            <input matInput type="text" [formControl]="brokerFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Broker')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Underwriting Type</mat-label>
                            <input matInput type="text" [formControl]="underwritingTypeFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Underwriting Type')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Broker Commission</mat-label>
                            <input matInput type="text" mask="separator.2" thousandSeparator="," [formControl]="brokerCommissionFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Broker Commission')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Pro Rata Type </mat-label>
                            <input matInput type="text" [formControl]="proRataTypeFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Pro Rata Type')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Premium Billing Interval</mat-label>
                            <input matInput type="text" [formControl]="premiumBillingIntervalFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Premium Billing Interval')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Billing Day Number</mat-label>
                            <input matInput type="text" [formControl]="billingDayNumberFormControl" [readonly]="true">
                        </mat-form-field>
                        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Billing Day Number')">help_outline
                        </mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>First Billing Date</mat-label>
                            <input [formControl]="firstBillingDateFormControl" [readonly]="true"
                                [matDatepicker]="firstBillingDatePicker" matInput>
                            <mat-datepicker #firstBillingDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon [matTooltip]="getInfoTooltip('First Billing Date')" class="info-icon">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                    </mat-grid-tile>
                </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" disabled>Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step  [completed]="policyProductPersonDataSource">
            <ng-template matStepLabel>Dependents</ng-template>
            <div *ngIf="policyProductPersonDataSource" class="mat-elevation-z8 table-container">
                <table mat-table multiTemplateDataRows [dataSource]="policyProductPersonDataSource" matSort >

                    <ng-container matColumnDef="select">
                        <th style="width: 36px" mat-header-cell *matHeaderCellDef>
                        </th>
                        <td style="width: 36px" mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="isSelected = true" disabled
                                 [checked]="isSelected">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="personName">
                        <th mat-header-cell *matHeaderCellDef>Member Name</th>
                        <td *matCellDef="let row" mat-cell> {{getPersonFullName(row.insuredPerson)}}</td>
                    </ng-container>

                    <ng-container matColumnDef="nationalIdNumber">
                        <th mat-header-cell *matHeaderCellDef>Member ID Number</th>
                        <td *matCellDef="let row" mat-cell> {{row?.insuredPerson?.nationalIdNumber}}</td>
                    </ng-container>

                    <ng-container matColumnDef="product">
                        <th mat-header-cell *matHeaderCellDef>Product</th>
                        <td *matCellDef="let row" mat-cell> {{row.product.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="coverStatus">
                        <th mat-header-cell *matHeaderCellDef>Cover Status</th>
                        <td *matCellDef="let row" mat-cell> {{coverStatusFormControl.value}}</td>
                    </ng-container>
                    <ng-container matColumnDef="startAndEndDate">
                        <th mat-header-cell *matHeaderCellDef>Start - End Date</th>
                        <td *matCellDef="let row" mat-cell> {{getStartAndEndDate()}}</td>
                    </ng-container>
                    <ng-container matColumnDef="nominatedBeneficiaryNationalIdNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Beneficiary ID Number</th>
                        <td *matCellDef="let row" mat-cell> {{row?.nominatedBeneficiaryNationalIdNumber}}</td>
                    </ng-container>

                  <tr mat-header-row *matHeaderRowDef="policyProductPersonLinksDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: policyProductPersonLinksDisplayedColumns;"></tr>

                </table>

                <mat-paginator [pageSizeOptions]="this.pageSizeOptions">
                </mat-paginator>

            </div>
            <div class="button-container">
                <button mat-raised-button matStepperPrevious color="primary">Back</button>
                <button mat-raised-button disabled color="warn">Clear</button>
  							<button mat-raised-button matStepperNext color="primary">Next</button>
	            </div>
        </mat-step>
	
			<!---------------------------->
			<!-- STEP: Variances:-->
			<!---------------------------->
			<mat-step [completed]="true">
				<ng-template matStepLabel>Variances</ng-template>
				<app-policy-product-variances [data]="policyDTO?.policyProductVariances"></app-policy-product-variances>
			</mat-step>
	
			<!---------------------------->
			<!-- STEP: Waivers:-->
			<!---------------------------->
			<mat-step [completed]="true">
				<ng-template matStepLabel>Waivers</ng-template>
				<app-policy-product-waivers [data]="policyDTO?.policyProductWaivers">
					<button mat-raised-button color="primary" (click)="onClickExit()">Exit</button>
				</app-policy-product-waivers>
			</mat-step>
    </mat-horizontal-stepper>
</div>
